export default __webpack_public_path__ + "static/media/tools.67cdcb2f.png";